// Get an element's absolute position on the page.
export function getOffset(el) {
    el = el.getBoundingClientRect();

    return {
        left: el.left + (window.scrollX || window.pageXOffset),
        top: el.top + (window.scrollY || window.pageYOffset),
    };
}



// WEBPACK FOOTER //
// ./js/common/utils/boxPosition.js